/* HFS sizing-chart enhancements (sandbox). Runs only where .hfs-chart-modern exists. */
(function () {
  function init() {
    var pc = document.querySelector(".hfs-chart-modern");
    if (!pc || pc.dataset.hfsChartReady === 'true') return;
    pc.dataset.hfsChartReady = 'true';

    /* Pin the Contents nav (and anchor scroll offset) just below the real sticky
       header, auto-measured so it never cuts off "On this page". */
    var hdr = document.querySelector(".section-header");
    if (hdr) {
      var setStick = function () { document.documentElement.style.setProperty("--hfs-stick", (hdr.offsetHeight + 16) + "px"); };
      setStick();
      window.addEventListener("resize", setStick, { passive: true });
    }

    /* ---- 1. Ensure wide tables scroll horizontally (skip if already wrapped) ---- */
    pc.querySelectorAll("table.hoverTable").forEach(function (tbl) {
      if (!tbl.closest(".hfs-scroll") && !tbl.closest(".table")) {
        var w = document.createElement("div");
        w.className = "hfs-scroll";
        tbl.parentNode.insertBefore(w, tbl);
        w.appendChild(tbl);
      }
      var wrapper = tbl.closest('.hfs-scroll, .table');
      if (wrapper) {
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('role', 'region');
        if (!wrapper.hasAttribute('aria-label') && !wrapper.hasAttribute('aria-labelledby')) {
          wrapper.setAttribute('aria-label', 'Shoe width chart');
        }
      }
    });

    /* ---- 2. Map women's / men's tables by the most recent heading (document order,
             nesting-independent so wrappers like .table / .hfs-scroll don't matter) ---- */
    var tables = {}, womenHead = null, menHead = null, lastH2 = null;
    pc.querySelectorAll("h2, table.hoverTable").forEach(function (el) {
      if (el.tagName === "H2") { lastH2 = el; return; }
      var label = lastH2 ? lastH2.textContent.toLowerCase() : "";
      if (label.indexOf("women") > -1) { tables.women = el; womenHead = lastH2; }
      else if (label.indexOf("men") > -1) { tables.men = el; menHead = lastH2; }
    });

    /* ---- 3. Keep the quiet shopping links beside the chart they follow; demote videos ---- */
    var heads = pc.querySelectorAll("h2"), videoH = null;
    heads.forEach(function (h) {
      var t = h.textContent.trim().toLowerCase();
      if (t === "video guides") videoH = h;
    });
    var midFinder = document.getElementById("hfs-finder-middle");
    if (midFinder && tables.women) {
      var womenWrap = tables.women.closest(".table") || tables.women.closest(".hfs-scroll") || tables.women;
      womenWrap.parentNode.insertBefore(midFinder, womenWrap.nextSibling);
    }
    var bottomFinder = document.getElementById("hfs-finder-bottom");
    if (bottomFinder && tables.men) {
      var menWrap = tables.men.closest(".table") || tables.men.closest(".hfs-scroll") || tables.men;
      menWrap.parentNode.insertBefore(bottomFinder, menWrap.nextSibling);
    }
    if (videoH) {
      var grp = [videoH], n = videoH.nextElementSibling;
      while (n && n.tagName !== "H2") { grp.push(n); n = n.nextElementSibling; }
      grp.forEach(function (el) { pc.appendChild(el); });
    }

    /* ---- 4. Find My Width tool, built from the on-page tables ---- */
    /* HFS (layout shift, growth priorities 2026-10-01): sections/main-page.liquid renders the calculator
       (snippets/hfs-width-finder.liquid) and How to Measure in place, so this only fills and wires them. Inserting
       them here after the first paint moved the whole page; that path remains for a page that does not render them. */
    var box = null, shell = document.getElementById("find-my-width");
    if (tables.women || tables.men) {
      box = buildWidthFinder(tables, pc.getAttribute("data-hfs-help-url") || "", shell, {
        women: pc.getAttribute("data-hfs-women-url"), men: pc.getAttribute("data-hfs-men-url")
      });
      if (box !== shell) {
        pc.insertBefore(box, pc.firstChild);
        var howto = document.getElementById("how-to-measure");
        if (howto) box.parentNode.insertBefore(howto, box.nextSibling);
      }
    } else if (shell) {
      shell.hidden = true; /* no chart tables to calculate from */
      shell.removeAttribute("data-hfs-pending");
    }

    /* ---- 5. Anchors + sticky Contents nav ---- */
    var sections = [];
    function anchor(el, id, label) {
      if (!el) return;
      el.id = id; el.classList.add("hfs-anchor");
      el.setAttribute('tabindex', '-1');
      sections.push({ id: id, label: label });
    }
    anchor(box, "find-my-width", "Find my width");
    anchor(document.getElementById("how-to-measure"), "how-to-measure", "How to measure");
    anchor(womenHead, "width-charts-women", "Women's width charts");
    anchor(menHead, "width-charts-men", "Men's width charts");

    var toc = document.getElementById("hfs-toc");
    if (toc && sections.length < 2) { toc.hidden = true; toc.removeAttribute("data-hfs-pending"); }
    if (toc && sections.length > 1) {
      var ul = toc.querySelector("ul");
      ul.textContent = ""; /* the page renders the usual links; rebuild them for the sections that exist */
      sections.forEach(function (s) {
        var li = document.createElement("li"), a = document.createElement("a");
        a.href = "#" + s.id; a.textContent = s.label; a.setAttribute("data-target", s.id);
        a.addEventListener('click', function (event) {
          if (typeof window.hfsJumpTo === 'function' && window.hfsJumpTo(s.id)) {
            event.preventDefault();
            return;
          }
          var target = document.getElementById(s.id);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView();
          target.focus({ preventScroll: true });
          history.replaceState(history.state, '', '#' + s.id);
        });
        li.appendChild(a); ul.appendChild(li);
      });
      toc.hidden = false;
      toc.removeAttribute("data-hfs-pending"); /* sections/main-page.liquid kept its space, invisible, until the links work */
      var links = ul.querySelectorAll("a");
      function spy() {
        var stick = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--hfs-stick"), 10) || 130;
        var cur = sections[0].id;
        sections.forEach(function (s) {
          var el = document.getElementById(s.id);
          if (el && el.getBoundingClientRect().top <= stick + 6) cur = s.id;
        });
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 2) cur = sections[sections.length - 1].id;
        links.forEach(function (a) {
          var active = a.getAttribute('data-target') === cur;
          a.classList.toggle('is-active', active);
          if (active) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      }
      window.addEventListener("scroll", spy, { passive: true });
      window.addEventListener("resize", spy, { passive: true });
      spy();
    }
  }

  function buildWidthFinder(tables, helpUrl, shell, browseUrls) {
    function parseFrac(txt) {
      txt = txt.replace(/["”]/g, "").trim();
      var m = txt.match(/^(\d+)\s+(\d+)\s*[⁄\/]\s*(\d+)$/);
      if (m) return parseInt(m[1], 10) + parseInt(m[2], 10) / parseInt(m[3], 10);
      var m2 = txt.match(/^(\d+(?:\.\d+)?)$/);
      if (m2) return parseFloat(m2[1]);
      var m3 = txt.match(/^(\d+)\s*[⁄\/]\s*(\d+)$/);
      if (m3) {
        /* HFS (Semrush/Clarity SC10): several chart rows run the whole number into the fraction
           ("5<sup>1</sup>⁄<sub>8</sub>" reads "51⁄8", which parsed as 6.375). A chart never writes an improper
           fraction, so the leading digits are the whole number: 51⁄8 is 5 1/8, 413⁄16 is 4 13/16. */
        var num = m3[1], den = parseInt(m3[2], 10);
        if (parseInt(num, 10) >= den) {
          for (var k = 1; k < num.length; k++) {
            var rest = parseInt(num.slice(k), 10);
            if (rest > 0 && rest < den) return parseInt(num.slice(0, k), 10) + rest / den;
          }
        }
        return parseInt(num, 10) / den;
      }
      return NaN;
    }
    function inchesText(v) {
      var sixteenths = Math.round(v * 16), whole = Math.floor(sixteenths / 16), rest = sixteenths % 16, d = 16;
      while (rest && rest % 2 === 0) { rest /= 2; d /= 2; }
      return rest ? (whole ? whole + " " : "") + rest + "/" + d : String(whole);
    }
    function widthCols(tbl) {
      var rows = tbl.querySelectorAll("tr");
      if (rows.length < 2) return [];
      var top = rows[0].querySelectorAll("th"), bot = rows[1].querySelectorAll("th"), cols = [];
      for (var i = 1; i < top.length; i++) cols.push({ name: top[i].textContent.trim(), codes: bot[i] ? bot[i].textContent.trim() : "" });
      return cols;
    }
    function sizesFor(tbl) {
      var a = [];
      tbl.querySelectorAll("td.shoesize").forEach(function (td) { a.push(td.textContent.replace(/size/i, "").trim()); });
      return a;
    }
    /* The audience collections retain a shopper's selected size, but their product-level filters do not
       establish a matching size/width variant or stock. Width taxonomy is unresolved: never translate chart
       codes into a different store width group. Optional product cards check literal codes on one live variant;
       the broader link never claims a complete exact-fit collection. No measurement leaves this calculator. */
    function shopLink(gender, size) {
      var fallback = gender === "women" ? "/collections/orthopedic-shoes-for-women" : "/collections/orthopedic-shoes-for-men-by-foot-condition";
      var url;
      try {
        url = new URL((browseUrls && browseUrls[gender]) || fallback, window.location.href);
        if (url.origin !== window.location.origin) throw new Error("External browse destination");
      } catch (error) { url = new URL(fallback, window.location.href); }
      if (size) url.searchParams.set("filter.p.m.custom.size", size);
      return url.pathname + url.search + url.hash;
    }
    function esc(text) {
      return String(text).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
    }

    var box = shell;
    if (!box) {
      box = document.createElement("div");
      box.className = "hfs-width-finder no-js-hidden"; /* the classes snippets/hfs-width-finder.liquid renders */
      box.setAttribute("data-hfs-pending", "");
      box.innerHTML =
        '<h2 class="hfs-wf-title">Find Your Width in Seconds</h2>' +
        '<p class="hfs-wf-sub">Choose your shoe size and enter your measured foot width for a starting point.<span class="hfs-wf-or" hidden> Or see your past sizes.</span></p>' +
        '<div class="hfs-wf-pastwrap" data-clarity-mask="true" data-nosnippet hidden>' +
          '<button type="button" class="hfs-wf-pasttoggle" aria-expanded="false" disabled>Your past sizes <span class="hfs-wf-count"></span> <span class="hfs-wf-caret">&#9662;</span></button>' +
          '<div class="hfs-wf-pastpanel" hidden><ul></ul></div>' +
        '</div>' +
        '<div class="hfs-wf-row">' +
        '<label>Shopping for<select id="hfs-wf-gender" disabled></select></label>' +
        '<label>Your shoe size<select id="hfs-wf-size" disabled></select></label>' +
        '<label>Foot width (inches)<input id="hfs-wf-measure" type="number" step="0.0625" min="2" max="7" placeholder="e.g. 4.25"></label>' +
        '<button type="button" id="hfs-wf-go" disabled>Find my width</button>' +
        "</div>" +
        '<div id="hfs-wf-result" class="hfs-wf-result" role="status" aria-live="polite" hidden></div>' +
        '<p class="hfs-wf-help">Need your measurement? <a href="#how-to-measure">See how to measure your foot width</a>.</p>';
    }

    var gSel = box.querySelector("#hfs-wf-gender"), sSel = box.querySelector("#hfs-wf-size");
    var mInput = box.querySelector("#hfs-wf-measure"), res = box.querySelector("#hfs-wf-result");
    /* Mask the complete personalized calculator surface in both server-rendered and fallback paths. */
    box.setAttribute("data-clarity-mask", "true");
    box.setAttribute("data-nosnippet", "");
    res.setAttribute("data-clarity-mask", "true");
    res.setAttribute("data-nosnippet", "");
    var resultTimer;
    /* HFS (Semrush/Clarity SC09): a result and its shopping link describe the inputs they were calculated from.
       Changing the gender, size, measurement or a past-size pick clears the result, cancels a result that is about
       to be written, so no recommendation or link refers to superseded inputs. */
    function clearResult() {
      clearTimeout(resultTimer);
      if (window.HFSWidthRecommendations) window.HFSWidthRecommendations.clear(box);
      res.innerHTML = "";
      res.hidden = true;
      [mInput, sSel].forEach(function (f) { f.removeAttribute("aria-invalid"); f.removeAttribute("aria-describedby"); });
    }
    Object.keys(tables).forEach(function (g) {
      var o = document.createElement("option"); o.value = g; o.textContent = g === "women" ? "Women" : "Men"; gSel.appendChild(o);
    });
    function fillSizes() {
      sSel.innerHTML = "";
      sizesFor(tables[gSel.value]).forEach(function (s) { var o = document.createElement("option"); o.value = s; o.textContent = "Size " + s; sSel.appendChild(o); });
    }
    fillSizes();
    gSel.addEventListener("change", function () { fillSizes(); clearResult(); });
    sSel.addEventListener("change", clearResult);
    mInput.addEventListener("input", clearResult);

    /* Logged-in customer's past sizes: pre-aim the tool + build an in-tool accordion */
    var past = document.getElementById("hfs-past");
    if (past) {
      function applyPick(g, s) {
        if ((g === "women" || g === "men") && tables[g]) { gSel.value = g; fillSizes(); }
        if (s) { for (var i = 0; i < sSel.options.length; i++) { if (sSel.options[i].value === s) { sSel.value = s; break; } } }
        clearResult();
      }
      applyPick((past.getAttribute("data-gender") || "").toLowerCase(), (past.getAttribute("data-size") || "").trim());

      var items = past.querySelectorAll("li");
      if (items.length) {
        var pw = box.querySelector(".hfs-wf-pastwrap"), pul = box.querySelector(".hfs-wf-pastpanel ul");
        items.forEach(function (li) {
          var g = (li.getAttribute("data-gender") || "").toLowerCase(), s = (li.getAttribute("data-size") || "").trim();
          var item = document.createElement("li"), btn = document.createElement("button");
          btn.type = "button"; btn.className = "hfs-wf-pastitem"; btn.innerHTML = li.innerHTML;
          btn.addEventListener("click", function () {
            applyPick(g, s);
            var mi = box.querySelector("#hfs-wf-measure"); if (mi) mi.focus();
          });
          item.appendChild(btn); pul.appendChild(item);
        });
        box.querySelector(".hfs-wf-count").textContent = "(" + items.length + ")";
        pw.hidden = false;
        var orSpan = box.querySelector(".hfs-wf-or"); if (orSpan) orSpan.hidden = false;
        var toggle = box.querySelector(".hfs-wf-pasttoggle"), panel = box.querySelector(".hfs-wf-pastpanel"), caret = box.querySelector(".hfs-wf-caret");
        toggle.addEventListener("click", function () {
          if (panel.hasAttribute("hidden")) { panel.removeAttribute("hidden"); toggle.setAttribute("aria-expanded", "true"); caret.innerHTML = "&#9652;"; }
          else { panel.setAttribute("hidden", ""); toggle.setAttribute("aria-expanded", "false"); caret.innerHTML = "&#9662;"; }
        });
      }
      /* The hidden data block has been copied into the visible accordion; drop it so past purchases are not left in a hidden DOM node */
      if (past.parentNode) past.parentNode.removeChild(past);
    }

    box.querySelector("#hfs-wf-go").addEventListener("click", function () {
      if (window.HFSWidthRecommendations) window.HFSWidthRecommendations.clear(box);
      var tbl = tables[gSel.value], size = sSel.value, measure = parseFloat(mInput.value);
      res.hidden = false;
      /* Write the result a moment after un-hiding the live region so screen readers announce it (WCAG 4.1.3). */
      var setResult = function (html, recommendation) {
        clearTimeout(resultTimer); res.innerHTML = "";
        resultTimer = setTimeout(function () {
          res.innerHTML = html;
          if (recommendation && window.HFSWidthRecommendations) {
            window.HFSWidthRecommendations.show(box, recommendation, shopLink(recommendation.audience, recommendation.size));
          }
        }, 60);
      };
      /* HFS a11y (PDP-35, WCAG 3.3.1): an error is tied to the field it is about (aria-invalid + aria-describedby) and focus goes there. */
      [mInput, sSel].forEach(function (f) { f.removeAttribute("aria-invalid"); f.removeAttribute("aria-describedby"); });
      var fail = function (msg, field) {
        setResult('<p class="hfs-wf-err" id="hfs-wf-err">' + msg + "</p>");
        field.setAttribute("aria-invalid", "true");
        field.setAttribute("aria-describedby", "hfs-wf-err");
        field.focus();
      };
      if (isNaN(measure)) { fail("Please enter your foot width in inches (e.g. 4.25).", mInput); return; }
      if (!isFinite(measure) || measure < 2 || measure > 7) { fail('Please enter a foot width between 2 and 7 inches.', mInput); return; }
      var rowEl = null;
      tbl.querySelectorAll("tr.rowstyle").forEach(function (tr) {
        var sc = tr.querySelector("td.shoesize");
        if (sc && sc.textContent.replace(/size/i, "").trim() === size) rowEl = tr;
      });
      if (!rowEl) { fail("Could not find that size.", sSel); return; }
      var cells = rowEl.querySelectorAll("td"), cols = widthCols(tbl), values = [], listed = [];
      for (var i = 1; i < cells.length && i <= cols.length; i++) values.push(parseFrac(cells[i].textContent));
      values.forEach(function (v, k) { if (!isNaN(v)) listed.push(k); });
      if (!listed.length) { fail('This chart does not have width information for that size. Please contact us for help.', sSel); return; }
      /* HFS (Semrush/Clarity SC10): the answer is the first listed width at or above the measurement. There is no
         fit recommendation for a measurement wider than the widest listed width, more than one chart step narrower
         than the narrowest, or falling among widths the row leaves blank; the shopper gets the facts, every width in
         their size and the contact page instead. */
      var lo = listed[0], hi = listed[listed.length - 1], chosen = -1, prev = -1;
      for (var n = 0; n < listed.length; n++) {
        if (values[listed[n]] >= measure) { chosen = listed[n]; prev = n ? listed[n - 1] : -1; break; }
      }
      var step = listed.length > 1 ? Math.max(0, (values[listed[1]] - values[lo]) / (listed[1] - lo)) : Infinity; // one listed width: no step to measure
      var outside = chosen === -1 ? "wide" : (chosen === lo && measure < values[lo] - step) ? "narrow" : (prev > -1 && chosen - prev > 1) ? "gap" : "";
      var who = gSel.value === "women" ? "women\u2019s" : "men\u2019s";
      var helpLink = helpUrl ? '<a class="hfs-wf-helplink" href="' + esc(helpUrl) + '">Need help choosing a width?</a>' : "";
      var shopping = '<div class="hfs-wf-shopping"><a class="hfs-wf-cta" href="' + esc(shopLink(gSel.value, size)) + '">Browse ' + esc(who + " size " + size) + ' shoes</a>' +
        '<p class="hfs-wf-scope">All widths shown. Check size, width and availability on the product page.</p>' + helpLink + '</div>';
      if (outside) {
        var why = outside === "wide"
          ? "That\u2019s wider than the widest width on our " + who + " chart for size " + size + " (" + cols[hi].name + ", " + inchesText(values[hi]) + " inches). Please check that you measured straight across the widest part of your foot, in inches."
          : outside === "narrow"
            ? "That\u2019s narrower than the narrowest width on our " + who + " chart for size " + size + " (" + cols[lo].name + ", " + inchesText(values[lo]) + " inches). Please check that you measured straight across the widest part of your foot, in inches."
            : "Our " + who + " chart doesn\u2019t list every width for size " + size + ", so we can\u2019t place that measurement.";
        setResult('<p class="hfs-wf-warn">' + esc(why) + "</p>" +
          '<div class="hfs-wf-resultrow">' + shopping + "</div>");
        return;
      }
      var w = cols[chosen];
      var warn = (measure < 2.8125 || measure > 6.125)
        ? '<p class="hfs-wf-warn">That measurement looks unusual. Most foot widths fall between about 2 13/16 and 6 1/8 inches. Please double-check you measured straight across the widest part of your foot in inches. Here is our best estimate:</p>'
        : "";
      setResult(warn +
        '<div class="hfs-wf-resultrow">' +
          '<div class="hfs-wf-answer">Your width is likely <strong>' + esc(w.name) + "</strong>" +
          (w.codes ? ' <span class="hfs-wf-codes">Chart codes: ' + esc(w.codes) + "</span>" : "") +
          '<p class="hfs-wf-fit-note">Width names and fit vary by brand. Use this chart as a starting point.</p></div>' +
          shopping +
        "</div>", { audience: gSel.value, size: size, widthName: w.name, widthCodes: w.codes });
    });
    /* Filled and wired: the controls the page serves disabled work from here on (snippets/hfs-width-finder.liquid) */
    Array.prototype.forEach.call(box.querySelectorAll("select, button"), function (control) { control.disabled = false; });
    box.removeAttribute("data-hfs-pending");
    return box;
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
